var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48.04px",
    height: "48.04px",
    viewBox: "0 -0.33 48.04 48.04",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffe48d;}.cls-2{fill:#ff6368;}.cls-3{fill:#e5c97a;}.cls-4{fill:#d34a5b;}.cls-5{fill:#354251;}.cls-6{fill:#9ad7d2;}.cls-7{fill:#74c1b9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "burger"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.07,15a.31.31,0,0,0,.31-.31h0V12.33a11,11,0,0,0-11-11H13.66a11,11,0,0,0-11,11v2.34A.3.3,0,0,0,3,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43,18.51H40.52l-5.87,5.87-5.87-5.87H5.09a3.73,3.73,0,0,0,0,7.46H43A3.73,3.73,0,0,0,43,18.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.71,35.67A11,11,0,0,0,13.66,46H34.42A11,11,0,0,0,45.37,35.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.54,14.67h0V12.33a11,11,0,0,1,11-11H13.66a11,11,0,0,0-11,11v2.34A.3.3,0,0,0,3,15h8.85A.31.31,0,0,1,11.54,14.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M10.21,22.24a3.74,3.74,0,0,1,3.73-3.73H5.09a3.73,3.73,0,1,0,0,7.46h8.85A3.74,3.74,0,0,1,10.21,22.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.56,35.67H2.71A11,11,0,0,0,13.66,46h8.85A11,11,0,0,1,11.56,35.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M45.07,16.34H3a1.67,1.67,0,0,1-1.67-1.67V12.33A12.34,12.34,0,0,1,13.66,0H34.42A12.34,12.34,0,0,1,46.75,12.33v2.34A1.68,1.68,0,0,1,45.07,16.34Zm-41-2.72H44a9.77,9.77,0,0,0-9.6-10.9H13.66A9.78,9.78,0,0,0,4.06,13.62Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "34.65 24.38 44.05 14.98 25.25 14.98 34.65 24.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "32.46 14.98 25.25 14.98 34.65 24.38 38.25 20.78 32.46 14.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M34.65,25.74a1.33,1.33,0,0,1-1-.4l-9.4-9.4a1.37,1.37,0,0,1,1-2.32h18.8a1.37,1.37,0,0,1,1,2.32l-9.4,9.4A1.33,1.33,0,0,1,34.65,25.74Zm-6.11-9.4,6.11,6.12,6.11-6.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M43,27.33H5.09a5.09,5.09,0,0,1,0-10.18H28.78a1.35,1.35,0,0,1,1,.4l4.91,4.91,4.91-4.91a1.35,1.35,0,0,1,1-.4H43A5.09,5.09,0,0,1,43,27.33Zm-6.64-2.72H43a2.37,2.37,0,0,0,0-4.74h-1.9ZM5.09,19.87a2.37,2.37,0,0,0,0,4.74H33l-4.74-4.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M40,32.93a5.28,5.28,0,0,1-3.6-1.38,2.7,2.7,0,0,0-3.83,0,5.42,5.42,0,0,1-7.2,0,2.69,2.69,0,0,0-3.82,0,5.39,5.39,0,0,1-7.2,0,2.72,2.72,0,0,0-3.83,0,5.28,5.28,0,0,1-3.6,1.38,5.28,5.28,0,0,1-3.6-1.38,2.63,2.63,0,0,0-1.91-.79,1.36,1.36,0,0,1,0-2.72A5.28,5.28,0,0,1,5,29.42a2.72,2.72,0,0,0,3.83,0,5.39,5.39,0,0,1,7.2,0,2.63,2.63,0,0,0,1.91.79,2.66,2.66,0,0,0,1.91-.79,5.39,5.39,0,0,1,7.2,0,2.72,2.72,0,0,0,3.83,0,5.42,5.42,0,0,1,7.2,0,2.72,2.72,0,0,0,3.83,0A5.24,5.24,0,0,1,45.47,28a1.36,1.36,0,0,1,0,2.72,2.67,2.67,0,0,0-1.92.79A5.28,5.28,0,0,1,40,32.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M34.42,47.38H13.66A12.32,12.32,0,0,1,1.36,35.75a1.37,1.37,0,0,1,1.35-1.44H45.37a1.37,1.37,0,0,1,1.35,1.44A12.32,12.32,0,0,1,34.42,47.38ZM4.26,37a9.61,9.61,0,0,0,9.4,7.63H34.42A9.61,9.61,0,0,0,43.82,37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M16.77,9.93a1.58,1.58,0,0,1-3.15,0A1.58,1.58,0,0,1,16.77,9.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M25.61,9.93a1.57,1.57,0,0,1-3.14,0A1.57,1.57,0,0,1,25.61,9.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M34.46,9.93a1.58,1.58,0,0,1-3.15,0A1.58,1.58,0,0,1,34.46,9.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M21.6,6a1.58,1.58,0,0,1-3.15,0A1.58,1.58,0,0,1,21.6,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M30.44,6A1.57,1.57,0,0,1,27.3,6,1.57,1.57,0,0,1,30.44,6Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.69ebb0f6578878d11cbae374003481df.svg";
export { ForwardRef as ReactComponent };